import { getPlatform, isElectron } from "../miscUtils";
import windowsDownload from "../../services/WindowsDownload";

export const downloadImageToFs = async (image_url: string, sample_id: string) => {
    if (image_url.startsWith('file://') && isElectron() && typeof window !== 'undefined' && (window as any).electron?.showSaveDialog) {
        const sanitizedUrl = stripUrlParams(image_url);
        const extension = getExtensionFromUrl(sanitizedUrl);
        const fileName = sample_id
            ? `${sample_id}.${extension || 'jpg'}`
            : getFileNameFromUrl(sanitizedUrl, 'image.jpg');

        const destinationPath = await (window as any).electron.showSaveDialog({
            defaultPath: fileName,
            filters: [{ name: 'Images', extensions: extension ? [extension] : ['jpg', 'jpeg', 'png'] }]
        });

        if (destinationPath) {
            await (window as any).electron.copyLocalFile({
                sourcePath: image_url,
                destinationPath
            });
        }
        return;
    }

    if(getPlatform() === 'windows') {
        try {
            await windowsDownload.downloadFileFromUrl(image_url)
            return
        } catch(ex) {
            console.log('error occurred in windows download')
        }
    }

    const sanitizedUrl = stripUrlParams(image_url);
    const extension = getExtensionFromUrl(sanitizedUrl);
    const fileName = sample_id
        ? `${sample_id}.${extension || 'jpg'}`
        : getFileNameFromUrl(sanitizedUrl, 'image.jpg');

    await downloadFile(image_url, fileName)
}

const getFileExtension = (format: 'pdf' | 'html' | 'json' | 'xls'): string => {
    const extensionMap: Record<'pdf' | 'html' | 'json' | 'xls', string> = {
        'pdf': 'pdf',
        'html': 'html',
        'json': 'json',
        'xls': 'xlsx'
    };
    return extensionMap[format];
}

export const downloadPdfToFs = async (report_url: string, job_id: string, format: 'pdf' | 'html' | 'json' | 'xls' = 'pdf') => {
    if (getPlatform() === 'windows') {
      try {
        await windowsDownload.downloadFileFromUrl(report_url)
        return
      } catch (ex) {
        console.log('error occurred in windows download')
      }
    }

    const extension = getFileExtension(format);
    const fileName = `report_${job_id}.${extension}`
    await downloadFile(report_url, fileName)
}

const stripUrlParams = (url: string) => {
    return url.split('#')[0].split('?')[0];
}

const getFileNameFromUrl = (url: string, fallback: string) => {
    try {
        const parsed = new URL(url, window.location.href);
        const fileName = parsed.pathname.split('/').pop();
        return fileName && fileName.length > 0 ? fileName : fallback;
    } catch {
        const parts = url.split('/');
        const fileName = parts[parts.length - 1];
        return fileName || fallback;
    }
};

const getExtensionFromUrl = (url: string) => {
    const fileName = getFileNameFromUrl(url, '');
    const lastDot = fileName.lastIndexOf('.');
    return lastDot >= 0 ? fileName.slice(lastDot + 1).toLowerCase() : '';
};

const triggerBrowserDownload = (url: string, fileName?: string) => {
    const link = document.createElement('a');
    link.href = url;
    if (fileName) {
        link.setAttribute('download', fileName);
    }
    link.rel = 'noopener';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const downloadFile = async (url: string, fileName?: string) => {
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {}
        });
        if (!response.ok) {
            throw new Error(`Download failed with status ${response.status}`);
        }
        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const resolvedName = fileName || getFileNameFromUrl(url, 'download');
        const link = document.createElement("a");
        link.href = objectUrl;
        link.setAttribute("download", resolvedName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
    } catch (err) {
        console.log(err);
        triggerBrowserDownload(url, fileName);
    }
};
